import { Link } from "@tanstack/react-router";
import { User } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Img } from "@/components/ui/img";
import type { ProfileWithMeta } from "./types";

export function SettingsHeader({
  profile,
}: {
  profile: ProfileWithMeta;
}) {
  return (
    <header className="mb-8 flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <h1
          className="text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          Postavke
        </h1>
      </div>

      <div className="flex shrink-0 items-center gap-3">
        <div className="flex size-10 items-center justify-center overflow-hidden rounded-full border border-border/60 bg-muted/40">
          {profile.profileImageUrl ? (
            <Img src={profile.profileImageUrl} alt={profile.userName ?? "Terapeut"} className="size-full object-cover" />
          ) : (
            <User className="size-5 text-muted-foreground/50" />
          )}
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-foreground">{profile.userName ?? "Terapeut"}</p>
          <Button asChild variant="link" className="h-auto p-0 text-xs text-primary">
            <Link to="/therapists/$therapistId" params={{ therapistId: profile.slug ?? profile.id }}>
              Pogledaj javni profil
            </Link>
          </Button>
        </div>
      </div>
    </header>
  );
}
